export default class ShopifyNewsletter extends HTMLElement {
  email: string | null = null

  static get observedAttributes() {
    return ['email']
  }

  constructor() {
    super()

    this.email = null
  }

  attributeChangedCallback(name: string, oldValue: any, newValue: any) {
    if (oldValue === newValue) return

    if (name === 'email') {
      this.email = newValue
    }
  }
}

customElements.define('shopify-newsletter', ShopifyNewsletter);
